import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MyTaskCounts } from '@/features/w/[identifier]/dashboard/tasks/{components}/MyTaskCounts';
import { useIntercomGuide } from '@/hooks/useIntercomGuide';

export const TasksDashboard = () => {
  const { setTitle, setBreadcrumbs } = useNavState();

  useEffect(() => setTitle('タスクボード'), []);
  useEffect(() => setBreadcrumbs([]), []);

  useIntercomGuide();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <MyTaskCounts />
      </div>
    </WorkspaceLayout>
  );
};
